import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { Link } from 'react-router-dom';

const Services = () => {
  useEffect(() => {
    document.title = 'Affordable Services At KumbhaaTech Solutions';
    return () => {
      document.title = 'Leading Software Company - KumbhaaTech Solutions';
    };
  }, []);

  const servicesData = [
    {
      id: 1,
      img: 'assets/webdevelopment.svg',
      // stimg: 'assets/images/KT-RD-WEB.gif',
      title: 'Quality Website Development',
      description: 'Create stunning, responsive websites that deliver an excellent user experience and reflect your brand\'s identity',
      link: '/affordable-website-design-services-chennai',
    },
    {
      id: 4,
      img: 'assets/software.svg',
      // stimg: 'assets/images/KT-software.gif',
      title: 'Professional Software Services',
      description: 'Develop custom software solutions tailored to your business needs, enhancing efficiency and productivity',
      link: '/cheap-PHP-MYSQL-software-customization-chennai',
    },
    {
      id: 2,
      img: 'assets/Digitalmarketing.svg',
      // stimg: 'assets/images/KT-digital.gif',
      title: 'Strategic Digital Marketing',
      description: 'Develop comprehensive digital marketing strategies, including social media marketing and email campaigns, to drive traffic and increase conversions',
      link: '/affordable-strategic-digital-marketing-chennai',
    },
    {
      id: 3,
      img: 'assets/content writing.svg',
      // stimg: 'assets/images/KT-content-rd.gif',
      title: 'Expert Content Writing',
      description: 'Deliver engaging, SEO-optimized content that captivates your audience and boosts your search engine rankings.',
      link: '/cheap-content-writing-seo-chennai',
    },

    {
      id: 5,
      img: 'assets/domine-regisrtaion.svg',
      // stimg: 'assets/images/KT-domain.gif', 
      title: 'Domain Registration',
      description: 'Secure your online presence with hassle-free domain registration services.',
      link: '/cheap-domain-registration-chennai',
    },
    {
      id: 7,
      img: 'assets/domine.svg',
      // stimg: 'assets/images/KT-seo.gif',
      title: 'Effective SEO',
      description: 'Improve your website\'s visibility on search engines with our proven SEO techniques.',
      link: '/affordable-seo-site-ranking-service-chennai',
    },
    {
      id: 6,
      img: 'assets/hosting.png',
      // stimg: 'assets/images/KT-domain.png',
      title: 'Web Hosting',
      description: 'Discover our affordable website hosting solutions designed to meet your needs without breaking your budget.',
      link: '/web-hosting-services',
    },

    {
      id: 9,
      img: 'assets/telemarketing.svg',
      // stimg: 'assets/images/telemarketing-b.gif',
      title: 'Telemarketing & Telesales ',
      description: 'Boost your sales and connect with customers directly through our expert telemarketing and telesales services.  ',
      link: '/looking-for-affordable-telemarketing-service-chennai',

    },
    {
      id: 8,
      img: 'assets/academic.png',
      // stimg: 'assets/images/KT-academic-writing-red.gif',
      title: 'Comprehensive Academic Writing',
      description: 'Receive expertly crafted academic papers and research content tailored to your requirements.',
      link: '/affordable-MBA-academic-writing-service-affordable-chennai',
    },

  ];

  return (
    <>
      <Header />

      <div className="custom-banner-1">
        <div className="container">
          <div className="custom-banner-content">
            <div className="left-content">
              <h1>
                Best <span className='o_blue_white'>Software Development </span>Company for Digital Success.
              </h1>
            </div>
            <div className="right-content">
              <hr
                className="orange-line"
                style={{ height: '5px', width: '50px', background: '#003bfd', opacity: '1' }}
              />
              <p>
                Affordable Services for Your Business Needs. From website development, software development, and digital marketing to SEO, SOP, and assignment writing, we’ve got you covered.
              </p>
              <Link className="text-white" to="/kumbhatech-affordable-website-design-chennai">
                Get In Touch <i className="fa fa-angle-right abt-btn-blue" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section className="key-module-bg" >
        <div className="container">
          <div className="features-courseProject">
            <div className="row">
              {/* <div className="col-lg-7 ser-he">
                <h2>Turn Your Ideas Into <span className='o_blue_white'>Innovative</span> Software <span className='o_blue_white'>Solutions</span> with Our Expert Services</h2>
                <br />
                <p>From custom software development to cutting-edge technologies, we deliver end-to-end solutions that drive success for your business. Our tailored services help you build robust and scalable products, with a focus on performance and user experience.</p>
              </div> */}
              <div className="key-modules-container">
                {servicesData.map(service => (
                  <div key={service.id} className="key-module">
                    <div className="key-image-container">
                      <img
                        src={service.img}
                        className="static-image"
                        loading="lazy"
                        decoding="async"
                        alt="our affordable services"
                      />
                    </div>
                    <h5 className='text-black'>{service.title}</h5>
                    <p>{service.description}</p>
                    <br />
                    <Link to={service.link} className="explore-button">
                      <span className="explore-texts">Explore More</span>
                      <span className="arrows">&rarr;</span>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Services;
